export default class About {
  /* ===================================
   *  CONSTRUCTOR
   * =================================== */
  constructor() {
    this.bindEvents();
  }

  /* ===================================
   *  EVENTS
   * =================================== */
  bindEvents() {
    if ($(".section-our-stories").length > 0) {
      this.ourStoriesSetup();
    }
  }

  /* ===================================
   *  METHODS
   * =================================== */
  ourStoriesSetup() {
    // Get elements
    const timeList = $(".time-list");
    const timeItems = timeList.find(".time-item");
    const storyList = $(".story-list");
    const storyItems = storyList.find(".story-item");

    let isAnimating = false;
    let autoPlayTimer;

    // Initialize first slide
    function initializeFirstSlide() {
      const firstItem = timeItems.first();
      if (firstItem.length > 0) {
        const firstYear = firstItem.data("year");

        // Set first item as active
        timeItems.removeClass("active past");
        firstItem.addClass("active");

        // Set corresponding story as active
        storyItems.removeClass("active");
        storyItems.filter(`[data-year="${firstYear}"]`).addClass("active");
      }
    }

    // Initialize on load
    initializeFirstSlide();

    // Handle time item click
    timeItems.on("click", function () {
      if (isAnimating) return;

      // Prevent interaction during animation
      isAnimating = true;
      setTimeout(() => {
        isAnimating = false;
      }, 500);

      const selectedYear = $(this).data("year");

      // Update active states
      timeItems.removeClass("active");
      $(this).addClass("active");

      storyItems.removeClass("active");
      // Add past class to years before selected year
      timeItems.each(function () {
        const itemYear = $(this).data("year").toString();
        const selectedYearNum = selectedYear.toString();

        // Handle special case for "2024-2" format
        const getYearNumber = (yearStr) => {
          if (yearStr.includes("-")) {
            return parseInt(yearStr.split("-")[0]);
          }
          return parseInt(yearStr);
        };

        const itemYearNum = getYearNumber(itemYear);
        const selectedYearNumParsed = getYearNumber(selectedYearNum);

        if (itemYearNum < selectedYearNumParsed) {
          $(this).addClass("past");
        } else {
          $(this).removeClass("past");
        }
      });
      storyItems.filter(`[data-year="${selectedYear}"]`).addClass("active");

      // Scroll time list if needed
      const itemPosition = $(this).position().left;
      const listWidth = timeList.width();
      const itemWidth = $(this).outerWidth();

      // Calculate safe zone boundaries (20% from each edge)
      const safeZoneLeft = listWidth * 0.3;
      const safeZoneRight = listWidth * 0.7;

      if (itemPosition > safeZoneRight) {
        // Scroll right if item is in right 20% zone
        timeList.animate(
          {
            scrollLeft:
              timeList.scrollLeft() + (itemPosition - safeZoneRight) + 100,
          },
          500
        );
      } else if (itemPosition < safeZoneLeft) {
        // Scroll left if item is in left 20% zone
        timeList.animate(
          {
            scrollLeft: timeList.scrollLeft() + (itemPosition - safeZoneLeft),
          },
          500
        );
      }

      // Reset autoplay timer on manual interaction
      resetAutoPlay();
    });

    // Auto play functionality
    function autoPlay() {
      if (isAnimating) return;

      const activeItem = timeItems.filter(".active");
      let nextItem;

      if (activeItem.length === 0) {
        nextItem = timeItems.first();
      } else {
        nextItem = activeItem.next(".time-item");
        if (nextItem.length === 0) {
          nextItem = timeItems.first();
        }
      }

      nextItem.trigger("click");
    }

    function resetAutoPlay() {
      clearInterval(autoPlayTimer);
      autoPlayTimer = setInterval(autoPlay, 4000);
    }

    // Start autoplay
    resetAutoPlay();
  }
}
